import Loading from "../../utils/Loading"; //获取加载组件
import { ElMessage, ElMessageBox } from "element-plus";
import { WebsiteUrl } from "../../utils";

import Api_Universal from "../../api/FrontEnd/Universal";

export default {
	name: 'ModuleBox',
	components: {
		
	},
	data(){
		return{
			WaveImageUrl:WebsiteUrl()+'/images/ModuleBottomWave.png',

			LogoData:"",
			NavData:[],
			CompanyData:{},
			QRCodeData:{},
			ICP:"",

		}
	},
	methods:{
		GetBottomElement(){
			let RequestData = {

			};
			let ReturnData = Api_Universal.GetBottomElement(RequestData);
			ReturnData.then(response => {
				//console.log(response);
				let State = response['Data'][0].State;
				let Message = response['Data'][0].Message;
				if(State == 'Success'){
					let Data = JSON.parse(response['Data'][0].Data);
					// console.log(Data);
					this.LogoData = Data.LogoData[0].Image.Url;
					this.NavData = Data.NavData;
					this.CompanyData = Data.CompanyData;
					this.QRCodeData = Data.QRCodeData;
					this.ICP =  Data.ICP;
				}else{
					ElMessage.error(Message);
				}
			})
		},

		NavClick(Data){
			// console.log(Data);

			this.$router.push(Data.Path);

			// Loading.LoadingShow();
			// let ParameterData = {};
			// let ReturnData = Api_Test.GetDemo(ParameterData);
			// ReturnData.then(response => {
			// 	Loading.LoadingHide();
			// 	console.log(response);
			// })

		},

		onToHome(){
			this.$router.push("/");
		},
		onToICP(){
			window.open('https://beian.miit.gov.cn/', '_blank');
		}
		

	},
	mounted(){
		this.GetBottomElement();
	}
}

